// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import iView from 'iview'
import 'iview/dist/styles/iview.css'
import fly from 'flyio'
import axios from 'axios'
import config from './router/axios/config'
import baseURL from './baseURL/config'
import '../static/normalize/normalize.less'
import '../static/less/common.less'
import './assets/icon/iconfont.css'

Vue.use(router)
Vue.use(iView)
Vue.config.productionTip = false
Vue.prototype.baseURL = baseURL;//注册全局接口URl
Vue.prototype.$ajax = axios;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {App}
})



// WEBPACK FOOTER //
// ./src/main.js